import React, { useEffect, useState } from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';
import {
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
}
    from 'mdb-react-ui-kit';
import moment from 'moment';
import axios from 'axios';
import { baseURL } from '../../api/baseURL';

const CustomerPage = ({ open, toggleOpen, token }: any) => {
    const data = open && typeof open === 'object' ? open : null;
    const [orders, setOrders] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [ratings, setRatings] = useState<any[]>([]);
    const [ratingsLoading, setRatingsLoading] = useState(false);

    useEffect(() => {
        if (data?._id && token) {
            setLoading(true);
            axios.get(`${baseURL}/customer-orders?userId=${data._id}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then((response: any) => {
                    setOrders(response?.data?.orders || []);
                })
                .catch(() => {
                    setOrders([]);
                })
                .finally(() => setLoading(false));

            setRatingsLoading(true);
            axios.get(`${baseURL}/customer-ratings?customer_id=${data._id}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then((response: any) => {
                    setRatings(response?.data?.ratings || []);
                })
                .catch(() => {
                    setRatings([]);
                })
                .finally(() => setRatingsLoading(false));
        } else {
            setOrders([]);
            setRatings([]);
        }
    }, [data?._id, token]);

    return (
        <MDBModal open={!!open} onClose={() => { toggleOpen() }} tabIndex='-1'>
            <MDBModalDialog size='fullscreen'>
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Customer</MDBModalTitle>
                        <MDBBtn floating onClick={() => { toggleOpen() }} style={{ display: 'flex', padding: 5, height: 30, width: 30 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
                                <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" stroke="#FFF" fill="#FFF"></path>
                            </svg>
                        </MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody style={{ backgroundColor: '#191c24' }}>
                        {!data ? (
                            <div style={{ color: '#fff', padding: 24 }}>No customer selected.</div>
                        ) : (
                        <>
                        <div style={{
                            marginBottom: 16,
                            padding: '14px 18px',
                            background: 'linear-gradient(135deg, rgba(41,182,247,0.18), rgba(41,182,247,0.06))',
                            border: '1px solid rgba(41,182,247,0.35)',
                            borderRadius: 12,
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 24,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}>
                            <div style={{ flex: '1 1 240px' }}>
                                <div style={{ fontSize: 12, color: '#8ED4FF', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 4 }}>Name</div>
                                <div style={{ fontSize: 22, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.2 }}>{data?.name || "-"}</div>
                                <div style={{ marginTop: 8, fontSize: 14, color: 'rgba(255,255,255,0.85)' }}>
                                    {data?.countryCode || ''} {data?.contact || "-"} · {data?.email || "-"}
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 24 }}>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: 12, color: '#8ED4FF', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 4 }}>Bookings</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: '#FFFFFF' }}>{data?.numberOfBookings ?? 0}</div>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: 12, color: '#8ED4FF', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 4 }}>Total Spend</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: '#FFFFFF' }}>{`₹ ${Math.round(data?.totalSpend ?? 0).toLocaleString('en-IN')}`}</div>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: '100%', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 10 }}>
                            <div style={{ padding: 10 }}>
                                <span style={{ fontSize: 18, fontWeight: 'bold', color: '#FFFFFF' }}>Details</span>
                            </div>
                            <div style={{ margin: '10px' }}>
                                <div style={{ marginBottom: 15 }}>
                                    <span style={{ display: 'block', paddingBottom: 5, fontSize: 16 }}>Last Used Address</span>
                                    <span style={{ display: 'block', padding: '7px 10px', fontSize: 16, borderBottom: '1px solid lightgray' }}>{data?.lastUsedAddress || "-"}</span>
                                </div>
                                <div style={{ marginBottom: 15 }}>
                                    <span style={{ display: 'block', paddingBottom: 5, fontSize: 16 }}>Status</span>
                                    <span style={{ display: 'block', padding: '7px 10px', fontSize: 16, borderBottom: '1px solid lightgray' }}>{data?.is_blocked ? "Blocked" : "Active"}</span>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: '100%', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 10, marginTop: 10 }}>
                            <div style={{ padding: 10 }}>
                                <span style={{ fontSize: 18, fontWeight: 'bold', color: '#FFFFFF' }}>Previous Shoots</span>
                            </div>
                            <div style={{ margin: '10px' }}>
                                {loading ? (
                                    <span style={{ fontSize: 14, color: '#9e9e9e' }}>Loading…</span>
                                ) : orders.length === 0 ? (
                                    <span style={{ fontSize: 14, color: '#9e9e9e' }}>No previous shoots</span>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Category</th>
                                                    <th>Date</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orders.map((o: any) => (
                                                    <tr key={o?.receipt_id}>
                                                        <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{o?.receipt_id}</td>
                                                        <td>{o?.categoryData?.name || "-"}</td>
                                                        <td>{o?.eventTime?.from ? moment(new Date(o.eventTime.from)).format('MMMM Do YYYY') : "-"}</td>
                                                        <td>{o?.status || "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ width: '100%', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 10, marginTop: 10 }}>
                            <div style={{ padding: 10 }}>
                                <span style={{ fontSize: 18, fontWeight: 'bold', color: '#FFFFFF' }}>Photographer Ratings of This Customer</span>
                                <span style={{ fontSize: 12, color: '#9e9e9e', display: 'block', marginTop: 2 }}>Internal only — never shown to the customer or other photographers</span>
                            </div>
                            <div style={{ margin: '10px' }}>
                                {ratingsLoading ? (
                                    <span style={{ fontSize: 14, color: '#9e9e9e' }}>Loading…</span>
                                ) : ratings.length === 0 ? (
                                    <span style={{ fontSize: 14, color: '#9e9e9e' }}>No ratings from photographers yet</span>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Stars</th>
                                                    <th>Comment</th>
                                                    <th>Photographer</th>
                                                    <th>Order</th>
                                                    <th>Rated On</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ratings.map((r: any, idx: number) => (
                                                    <tr key={`${r.receipt_id}-${idx}`}>
                                                        <td>
                                                            <span className={`badge ${r.stars <= 2 ? 'badge-outline-danger' : r.stars === 3 ? 'badge-outline-warning' : 'badge-outline-success'}`}>
                                                                {'★'.repeat(r.stars)}{'☆'.repeat(5 - r.stars)}
                                                            </span>
                                                        </td>
                                                        <td>{r.comment || '—'}</td>
                                                        <td>{r.photographer_name || '—'}</td>
                                                        <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{r.receipt_id}</td>
                                                        <td>{r.rated_at ? moment(new Date(r.rated_at)).format('MMMM Do YYYY') : '—'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                        </>
                        )}
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
}

export default CustomerPage;
